import React from "react";

import "./HiddenSeperatorConfig.css";

export const HOR_SEPERATOR = {
  className: "grid-resize-handle-wrapper",
  children: <div className="grid-resize-handle-horizontal" />,
};

export const VERT_SEPERATOR = {
  className: "grid-resize-handle-wrapper",
  children: <div className="grid-resize-handle-vertical" />,
};
